import RootContainer from './RootContainer';
import LandingPage from './HealthLandingPage';

export default {
  RootContainer,
  LandingPage
};



// WEBPACK FOOTER //
// ./src/components/Pages/Health/index.js